<template>
    <div>
        <div class="listing-header mb-4" v-if="!cantEdit">
            <div class="title-breadcrumb" />
            <div class="header-buttons">
                <button
                    v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                    @click="save(4)"
                    :disabled="isSaving || cantEdit || isLoadingEdit || checkIsLoading()"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <vss-select
                        :id="generateId(1)"
                        ref="empresaSelect"
                        title="empresa"
                        :options="empresaSelect"
                        v-model="empresaSelected"
                        :required="true"
                        :invalid="empresaSelected == null"
                        :loading="empresasLoading"
                        invalidWhenDisabled
                        :disabled="cantEdit || isLoadingEdit"
                        @onBlurFunction="sendIsChanged('empresa')"
                        @search="carregarEmpresas"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(5)"
                        ref="clienteSelect"
                        title="cliente"
                        :placeholder="
                            clienteSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        searchable
                        clearable
                        :options="clienteSelect"
                        v-model="clienteSelected"
                        :required="true"
                        :invalid="clienteSelected == null"
                        :loading="clienteLoading"
                        @search="loadCliente"
                        invalidWhenDisabled
                        :disabled="cantEdit || isLoadingEdit || disabledByEmpresa"
                        @onBlurFunction="sendIsChanged('cliente')"
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        (pdadetalhe['propriedade'] && !pdadetalhe['propriedade'].oculta) ||
                        !pdadetalhe['propriedade']
                    "
                    v-show="!disabledByNoPropriedade"
                >
                    <vss-select
                        :id="generateId(10)"
                        ref="propriedadeSelect"
                        :title="
                            pdadetalhe['propriedade'] && !isNull(pdadetalhe['propriedade'].label)
                                ? pdadetalhe['propriedade'].label
                                : 'propriedade'
                        "
                        :placeholder="
                            propriedadeSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        :disableMLtitle="
                            pdadetalhe['propriedade'] && !isNull(pdadetalhe['propriedade'].label)
                        "
                        searchable
                        clearable
                        :options="propriedadeSelect"
                        v-model="propriedadeSelected"
                        :required="
                            (pdadetalhe['propriedade'] &&
                                pdadetalhe['propriedade'].obrigainclusao) ||
                            !pdadetalhe['propriedade']
                        "
                        :invalid="
                            (pdadetalhe['propriedade'] &&
                                pdadetalhe['propriedade'].obrigainclusao &&
                                propriedadeSelected == null) ||
                            (!pdadetalhe['propriedade'] && propriedadeSelected == null)
                        "
                        :loading="propriedadeLoading"
                        @search="loadPropriedade"
                        invalidWhenDisabled
                        :disabled="cantEdit || isLoadingEdit || disabledByCliente"
                        @onBlurFunction="sendIsChanged('propriedade')"
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="(pdadetalhe['area'] && !pdadetalhe['area'].oculta) || !pdadetalhe['area']"
                    v-show="!disabledByNoPropriedade"
                >
                    <vss-select
                        :id="generateId(15)"
                        ref="areaSelect"
                        :title="
                            pdadetalhe['area'] && !isNull(pdadetalhe['area'].label)
                                ? pdadetalhe['area'].label
                                : 'area'
                        "
                        :placeholder="
                            areaSelect.length > 0 ? 'selecione-uma-opcao' : 'sem-opcao-de-selecao'
                        "
                        :disableMLtitle="pdadetalhe['area'] && !isNull(pdadetalhe['area'].label)"
                        searchable
                        clearable
                        :options="areaSelect"
                        v-model="areaSelected"
                        :required="
                            (pdadetalhe['area'] && pdadetalhe['area'].obrigainclusao) ||
                            !pdadetalhe['area']
                        "
                        :invalid="
                            (pdadetalhe['area'] &&
                                pdadetalhe['area'].obrigainclusao &&
                                areaSelected == null) ||
                            (!pdadetalhe['area'] && areaSelected == null)
                        "
                        :loading="areaLoading"
                        @search="loadArea"
                        invalidWhenDisabled
                        :disabled="cantEdit || isLoadingEdit || disabledByPropriedade"
                        @onBlurFunction="sendIsChanged('area')"
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        (pdadetalhe['talhao'] && !pdadetalhe['talhao'].oculta) ||
                        !pdadetalhe['talhao']
                    "
                    v-show="!disabledByNoPropriedade"
                >
                    <vss-select
                        :id="generateId(20)"
                        ref="talhaoSelect"
                        :title="
                            pdadetalhe['talhao'] && !isNull(pdadetalhe['talhao'].label)
                                ? pdadetalhe['talhao'].label
                                : 'talhao'
                        "
                        :placeholder="
                            talhaoSelect.length > 0 ? 'selecione-uma-opcao' : 'sem-opcao-de-selecao'
                        "
                        :disableMLtitle="
                            pdadetalhe['talhao'] && !isNull(pdadetalhe['talhao'].label)
                        "
                        searchable
                        clearable
                        :options="talhaoSelect"
                        v-model="talhaoSelected"
                        :required="
                            (pdadetalhe['talhao'] && pdadetalhe['talhao'].obrigainclusao) ||
                            !pdadetalhe['talhao']
                        "
                        :invalid="
                            (pdadetalhe['talhao'] &&
                                pdadetalhe['talhao'].obrigainclusao &&
                                talhaoSelected == null) ||
                            (!pdadetalhe['talhao'] && talhaoSelected == null)
                        "
                        :loading="talhaoLoading"
                        @search="loadTalhao"
                        invalidWhenDisabled
                        :disabled="cantEdit || isLoadingEdit || disabledByArea"
                        @onBlurFunction="sendIsChanged('talhao')"
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        (pdadetalhe['planosafra'] && !pdadetalhe['planosafra'].oculta) ||
                        !pdadetalhe['planosafra']
                    "
                    v-show="!disabledByNoPropriedade"
                >
                    <vss-select
                        :id="generateId(25)"
                        ref="planosafraSelect"
                        :title="
                            pdadetalhe['planosafra'] && !isNull(pdadetalhe['planosafra'].label)
                                ? pdadetalhe['planosafra'].label
                                : 'planosafra'
                        "
                        :placeholder="
                            planosafraSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        :disableMLtitle="
                            pdadetalhe['planosafra'] && !isNull(pdadetalhe['planosafra'].label)
                        "
                        searchable
                        clearable
                        :options="planosafraSelect"
                        v-model="planosafraSelected"
                        :required="
                            (pdadetalhe['planosafra'] && pdadetalhe['planosafra'].obrigainclusao) ||
                            !pdadetalhe['planosafra']
                        "
                        :invalid="validacaoPlanoSafra()"
                        :loading="planosafraLoading"
                        @search="loadPlanoSafra"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit ||
                            isLoadingEdit ||
                            disabledByTalhao ||
                            planosafraSelect.length < 1
                        "
                        @onBlurFunction="sendIsChanged('planosafra')"
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        (pdadetalhe['safra'] && !pdadetalhe['safra'].oculta) || !pdadetalhe['safra']
                    "
                >
                    <vss-select
                        :id="generateId(30)"
                        ref="safraSelect"
                        :title="
                            pdadetalhe['safra'] && !isNull(pdadetalhe['safra'].label)
                                ? pdadetalhe['safra'].label
                                : 'safra'
                        "
                        :placeholder="
                            safraSelect.length > 0 ? 'selecione-uma-opcao' : 'sem-opcao-de-selecao'
                        "
                        :disableMLtitle="pdadetalhe['safra'] && !isNull(pdadetalhe['safra'].label)"
                        searchable
                        clearable
                        :options="safraSelect"
                        v-model="safraSelected"
                        :required="
                            (pdadetalhe['safra'] && pdadetalhe['safra'].obrigainclusao) ||
                            !pdadetalhe['safra']
                        "
                        :invalid="
                            (pdadetalhe['safra'] &&
                                pdadetalhe['safra'].obrigainclusao &&
                                planosafraSelect.length < 1 &&
                                safraSelected == null) ||
                            (!pdadetalhe['safra'] && safraSelected == null)
                        "
                        :loading="safraLoading"
                        @search="loadSafra"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit || isLoadingEdit || disabledByPlanoSafra || disabledByTalhao
                        "
                        @onBlurFunction="sendIsChanged('safra')"
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        (pdadetalhe['cultura'] && !pdadetalhe['cultura'].oculta) ||
                        !pdadetalhe['cultura']
                    "
                >
                    <vss-select
                        :id="generateId(35)"
                        ref="culturaSelect"
                        :title="
                            pdadetalhe['cultura'] && !isNull(pdadetalhe['cultura'].label)
                                ? pdadetalhe['cultura'].label
                                : 'cultura'
                        "
                        :placeholder="
                            culturaSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        :disableMLtitle="
                            pdadetalhe['cultura'] && !isNull(pdadetalhe['cultura'].label)
                        "
                        searchable
                        clearable
                        :options="culturaSelect"
                        v-model="culturaSelected"
                        :required="
                            (pdadetalhe['cultura'] && pdadetalhe['cultura'].obrigainclusao) ||
                            !pdadetalhe['cultura']
                        "
                        :invalid="
                            (pdadetalhe['cultura'] &&
                                pdadetalhe['cultura'].obrigainclusao &&
                                planosafraSelect.length < 1 &&
                                culturaSelected == null) ||
                            (!pdadetalhe['cultura'] && culturaSelected == null)
                        "
                        :loading="culturaLoading"
                        @search="loadCultura"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit || isLoadingEdit || disabledByPlanoSafra || disabledByTalhao
                        "
                        @onBlurFunction="sendIsChanged('cultura')"
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        (pdadetalhe['motivovisita'] && !pdadetalhe['motivovisita'].oculta) ||
                        !pdadetalhe['motivovisita']
                    "
                >
                    <vss-select
                        :id="generateId(40)"
                        ref="motivoSelect"
                        :title="
                            pdadetalhe['motivovisita'] && !isNull(pdadetalhe['motivovisita'].label)
                                ? pdadetalhe['motivovisita'].label
                                : 'motivo-visita'
                        "
                        :placeholder="
                            motivoSelect.length > 0 ? 'selecione-uma-opcao' : 'sem-opcao-de-selecao'
                        "
                        :disableMLtitle="
                            pdadetalhe['motivovisita'] && !isNull(pdadetalhe['motivovisita'].label)
                        "
                        searchable
                        clearable
                        :options="motivoSelect"
                        v-model="motivoSelected"
                        :required="
                            pdadetalhe['motivovisita'] && pdadetalhe['motivovisita'].obrigainclusao
                        "
                        :invalid="
                            pdadetalhe['motivovisita'] &&
                            pdadetalhe['motivovisita'].obrigainclusao &&
                            motivoSelected == null
                        "
                        :loading="motivoLoading"
                        @search="loadMotivo"
                        invalidWhenDisabled
                        :disabled="cantEdit || isLoadingEdit"
                        @onBlurFunction="sendIsChanged('motivo')"
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        (pdadetalhe['assuntovisita'] && !pdadetalhe['assuntovisita'].oculta) ||
                        !pdadetalhe['assuntovisita']
                    "
                >
                    <vss-select
                        :id="generateId(45)"
                        ref="assuntoSelect"
                        :title="
                            pdadetalhe['assuntovisita'] &&
                            !isNull(pdadetalhe['assuntovisita'].label)
                                ? pdadetalhe['assuntovisita'].label
                                : 'assunto-visita'
                        "
                        :placeholder="
                            assuntoSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        :disableMLtitle="
                            pdadetalhe['assuntovisita'] &&
                            !isNull(pdadetalhe['assuntovisita'].label)
                        "
                        searchable
                        clearable
                        :options="assuntoSelect"
                        v-model="assuntoSelected"
                        :required="
                            pdadetalhe['assuntovisita'] &&
                            pdadetalhe['assuntovisita'].obrigainclusao
                        "
                        :invalid="
                            pdadetalhe['assuntovisita'] &&
                            pdadetalhe['assuntovisita'].obrigainclusao &&
                            assuntoSelected == null
                        "
                        :loading="assuntoLoading"
                        @search="loadAssunto"
                        invalidWhenDisabled
                        :disabled="cantEdit || isLoadingEdit || disabledByMotivo"
                        @onBlurFunction="sendIsChanged('assunto')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// #71157
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import AgroVisitaService from '@/services/agro/agrovisita/AgroVisitaService';
import ClienteService from '@/services/vendas/cliente/ClienteService';
import PropriedadeService from '@/services/agro/PropriedadeService';
import AreaService from '@/services/agro/AreaService';
import TalhaoService from '@/services/agro/TalhaoService';
import PlanoSafraService from '@/services/agro/planosafra/PlanoSafraService';
import CulturaService from '@/services/agro/CulturaService';
import MotivoService from '@/services/agro/TipoRtrService';
import AssuntoVisita from '@/services/agro/AssuntoRtrService';
import SafraService from '@/services/agro/SafraService';
import AgroVisitaValidation from '@/services/validations/agro/AgroVisitaValidation';

export default {
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        cantEdit: {
            type: Boolean,
            default: false,
        },
        updateSituacao: {
            type: Boolean,
            default: false,
        },
        deleteVisita: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // Verificar se integração vai afetar esta página
            empresaService: new EmpresaService(this.$http, this.$router),
            service: new AgroVisitaService(this.$http, this.$router),
            serviceCliente: new ClienteService(this.$http, this.$router),
            servicePropriedade: new PropriedadeService(this.$http, this.$router),
            serviceArea: new AreaService(this.$http, this.$router),
            serviceTalhao: new TalhaoService(this.$http, this.$router),
            servicePlanoSafra: new PlanoSafraService(this.$http, this.$router),
            serviceCultura: new CulturaService(this.$http, this.$router),
            serviceMotivo: new MotivoService(this.$http, this.$router),
            serviceAssuntoVisita: new AssuntoVisita(this.$http, this.$router),
            serviceSafra: new SafraService(this.$http, this.$router),

            validation: new AgroVisitaValidation(this.$root.msgs),
            agrovisita: {
                idagro_visitaerp: null,
                uuid: null,
                situacao: null,
                latitude: null,
                longitude: null,
                lastfix: null,
                tipogps: null,
                // ligações
                idusuario: null,
                idempresa: null,
                idcliente: null,

                uuidagro_propriedade: null,
                uuidagro_area: null,
                uuidagro_talhao: null,
                uuidagro_planosafra: null,

                idagro_safra: null,
                idagro_cultura: null, // cultura
                idagro_motivovisita: null, // tiportr
                idagro_assuntovisita: null, // assuntortr
                // Models
                empresa: null,
                cliente: null,
                propriedade: null,
                area: null,
                talhao: null,
                planosafra: null,
                safra: null,
                cultura: null,
                motivovisita: null,
                assuntovisita: null,
            },
            // Validação personalizada dos campos
            pdadetalhe: {},
            pdadetalheHasData: false,

            isLoading: false,
            isSaving: false,

            permissao: false,
            // Controles de empresa
            empresasLoading: false,
            empresaSelect: [],
            empresaSelected: null,
            disabledByEmpresa: true,
            // Controles de cliente
            clienteLoading: true,
            clienteSelect: [],
            clienteSelected: null,
            disabledByCliente: true,
            // Controles de propriedade
            propriedadeLoading: true,
            propriedadeSelect: [],
            propriedadeSelected: null,
            disabledByPropriedade: true,
            disabledByNoPropriedade: false,
            // Controles de area
            areaLoading: true,
            areaSelect: [],
            areaSelected: null,
            disabledByArea: true,
            // Controles de talhao
            talhaoLoading: true,
            talhaoSelect: [],
            talhaoSelected: null,
            disabledByTalhao: true,
            // Controles de planosafra
            planosafraLoading: true,
            planosafraSelect: [],
            planosafraSelected: null,
            disabledByPlanoSafra: true,
            // Controles de safra
            safraLoading: true,
            safraSelect: [],
            safraSelected: null,
            disabledBySafra: true,
            // Controles de cultura
            culturaLoading: true,
            culturaSelect: [],
            culturaSelected: null,
            disabledByCultura: true,
            // Controles de assunto
            assuntoLoading: true,
            assuntoSelect: [],
            assuntoSelected: null,
            disabledByAssunto: true,
            // Controles de motivo
            motivoLoading: true,
            motivoSelect: [],
            motivoSelected: null,
            disabledByMotivo: true,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            position: null,
            // Validação de carregamento de dados na edição
            countToLoad: 0,
            countLoaded: 0,
        };
    },
    watch: {
        agrovisita: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit('isChanged', true);
                }
            },
        },
        updateSituacao(val) {
            if (val) this.promptFinalizar();
        },
        deleteVisita(val) {
            if (val) this.promptDelete();
        },
        // countLoaded(val) {
        //   console.log(this.countToLoad, val);
        // },
        isLoadingEdit(val) {
            // console.log('isLoadingEdit', val);
            // avisa que agora vai poder haver mudanças
            if (this.isUpdate && !val) {
                setTimeout(() => {
                    this.$emit('isChanged', false);
                }, 1000);
            }
        },
    },
    created() {
        // caso seja update inicia validação de carregamento dos dados
        if (this.isUpdate) this.isLoadingEdit = true;

        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 1000);

        this.permissao = this.hasPermissionAccess('agro', 'agro-visita', 'agro-visita');
        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-visita' },
            });
        } else {
            // utilizado para os campos plano safra, motivo e assunto
            this.getModulo('AGROVISITA').detalhe.forEach((d) => {
                this.$set(this.pdadetalhe, d.campo.toLowerCase(), d);
                // Caso tenha dados em pdadetalhe
                this.pdadetalheHasData = true;
            });
            // pega da raiz
            this.carregarEmpresas('');

            if (this.isUpdate) {
                this.carregarDados();
                this.disabledByCliente = false;
            }
        }
    },
    methods: {
        checkIsLoading() {
            return (
                this.motivoLoading ||
                this.assuntoLoading ||
                this.culturaLoading ||
                this.safraLoading ||
                this.planosafraLoading ||
                this.talhaoLoading ||
                this.areaLoading ||
                this.propriedadeLoading ||
                this.clienteLoading ||
                this.empresasLoading
            );
        },
        generateId(numberId) {
            return this.$route.name + '-geral-' + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.service
                .findByUuid(this.$route.params.id)
                .then((value) => {
                    this.agrovisita = Object.assign({}, value.content);

                    this.$emit('situacao', this.agrovisita.situacao);
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    if (this.agrovisita.idagro_visitaerp != null) {
                        this.$emit('iderp', this.agrovisita.idagro_visitaerp);
                    }
                    this.isLoading = false;
                    this.countSelected();
                });
        },
        successPosition(position) {
            this.agrovisita.latitude = position.coords.latitude ? position.coords.latitude : 0;
            this.agrovisita.longitude = position.coords.longitude ? position.coords.longitude : 0;
            this.agrovisita.lastfix = position.timestamp ? position.timestamp : null;
            this.agrovisita.tipogps = position.coords.latitude ? 1 : 0;
            console.info(position);
        },
        errorPosition(e) {
            console.error('Geolocation error!', e);
        },
        save(situacao = 4) {
            this.agrovisita.situacao = situacao;

            this.isLoading = true;
            // pega alocalização através do navegador caso esteja liberado
            if (navigator.geolocation) {
                // console.log('Geolocation is supported by this browser');
                navigator.geolocation.getCurrentPosition(this.successPosition, this.errorPosition);
            } else {
                // console.log('Geolocation is not supported by this browser');
            }
            setTimeout(() => {
                // preenche id e uuid dos objetos dos selects
                this.agrovisita.idusuario = this.$store.state.user.usuario.id;
                this.agrovisita.idempresa =
                    this.empresaSelected != null ? this.empresaSelected.id : null;
                this.agrovisita.idcliente =
                    this.clienteSelected != null ? this.clienteSelected.id : null;
                this.agrovisita.uuidagro_propriedade =
                    this.propriedadeSelected != null ? this.propriedadeSelected.uuid : null;
                this.agrovisita.uuidagro_area =
                    this.areaSelected != null ? this.areaSelected.uuid : null;
                this.agrovisita.uuidagro_talhao =
                    this.talhaoSelected != null ? this.talhaoSelected.uuid : null;
                this.agrovisita.uuidagro_planosafra =
                    this.planosafraSelected != null ? this.planosafraSelected.uuid : null;
                this.agrovisita.idagro_safra =
                    this.safraSelected != null ? this.safraSelected.id : null;
                this.agrovisita.idagro_cultura =
                    this.culturaSelected != null ? this.culturaSelected.id : null;
                this.agrovisita.idagro_motivovisita =
                    this.motivoSelected != null ? this.motivoSelected.id : null;
                this.agrovisita.idagro_assuntovisita =
                    this.assuntoSelected != null ? this.assuntoSelected.id : null;

                // passa os dados para a validação
                if (
                    this.validation.validate(
                        this.agrovisita,
                        this.propriedadeSelect.length,
                        this.planosafraSelect.length,
                        this.pdadetalhe,
                        this.$refs
                    ) ||
                    situacao == 0
                ) {
                    // faz a cópia dos dados para não afetar os originais caso de erro
                    let agrovisitaTemp = Object.assign({}, this.agrovisita);

                    this.isSaving = true;
                    this.service
                        .save(agrovisitaTemp)
                        .then((value) => {
                            if (value.message == null) {
                                let msgText = 'msg-save-sucesso-n';
                                if (situacao == 4) {
                                    msgText = 'msg-edit-sucesso-n';
                                } else if (situacao == 1) {
                                    msgText = 'msg-agrovisita-finalizada';
                                } else if (situacao == 0) {
                                    msgText = 'msg-delete-sucesso-n';
                                }

                                // novo modelo de mensagem dinâmica
                                let msg = this.$t(msgText, { n: this.$t('agro-visita') });

                                this.$root.showMessage('success', msg, true, false);

                                // redireciona para a tela de ...... caso venha de lá
                                if (this.$route.query.tela) {
                                    this.redirectToPage();
                                } else if (situacao == 0) {
                                    setTimeout(() => {
                                        this.$router.push({ name: 'agro-visita-list' });
                                    }, 1000);
                                } else {
                                    // caso seja atualização de situalção
                                    this.$emit('situacao', this.agrovisita.situacao);
                                    // manda para a edição para adicionar os items
                                    this.redirectToEdit(value.content.uuid);
                                }
                                this.$emit('isChanged', false);
                            } else {
                                if (this.$t(value.message)) {
                                    this.$root.showMessage('alert', value.message, true);
                                } else {
                                    this.$root.showMessage(
                                        'error',
                                        'msg-problema-realizar-acao',
                                        true
                                    );
                                }
                            }
                        })
                        .catch((e) => {
                            this.$root.showMessage('error', 'msg-erro-load', true);
                        })
                        .finally(() => {
                            this.isSaving = false;
                            this.isLoading = false;
                        });
                } else {
                    this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                    this.isLoading = false;
                }
            }, 300);
        },
        redirectToEdit(id) {
            setTimeout(() => {
                this.$router.push({
                    name: 'agro-visita-edit',
                    params: { id: id },
                });
            }, 1000);
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela == 'agro-visita') {
                tempTela = 'agro-visita-edit';
                tempAba = 'empresa';
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query['id'] },
                    query: { abaSelecionada: tempAba },
                });
            }, 1000);
        },
        countSelected() {
            // Conta o tando de dados a serem carregados do servidor
            // console.log(this.isUpdate, this.isLoadingEdit);
            if (this.isUpdate && this.isLoadingEdit) {
                if (this.agrovisita.cliente && !this.isNull(this.agrovisita.cliente.nome)) {
                    this.countToLoad++;
                }
                if (
                    this.pdadetalhe.propriedade &&
                    !this.pdadetalhe.propriedade.oculta &&
                    this.agrovisita.propriedade &&
                    !this.isNull(this.agrovisita.propriedade.nome)
                ) {
                    this.countToLoad++;
                }
                if (
                    this.pdadetalhe.area &&
                    !this.pdadetalhe.area.oculta &&
                    this.agrovisita.area &&
                    !this.isNull(this.agrovisita.area.descricao)
                ) {
                    this.countToLoad++;
                }
                if (
                    this.pdadetalhe.talhao &&
                    !this.pdadetalhe.talhao.oculta &&
                    this.agrovisita.talhao &&
                    !this.isNull(this.agrovisita.talhao.descricao)
                ) {
                    this.countToLoad++;
                }
                if (
                    this.pdadetalhe.planosafra &&
                    !this.pdadetalhe.planosafra.oculta &&
                    this.agrovisita.planosafra &&
                    !this.isNull(this.agrovisita.planosafra.uuid)
                ) {
                    this.countToLoad++;
                } else {
                    if (
                        this.pdadetalhe.safra &&
                        !this.pdadetalhe.safra.oculta &&
                        this.agrovisita.safra &&
                        !this.isNull(this.agrovisita.safra.descricao)
                    ) {
                        this.countToLoad++;
                    }
                    if (
                        this.pdadetalhe.cultura &&
                        !this.pdadetalhe.cultura.oculta &&
                        this.agrovisita.cultura &&
                        !this.isNull(this.agrovisita.cultura.descricao)
                    ) {
                        this.countToLoad++;
                    }
                }
                if (
                    this.pdadetalhe.motivovisita &&
                    !this.pdadetalhe.motivovisita.oculta &&
                    this.agrovisita.motivovisita &&
                    !this.isNull(this.agrovisita.motivovisita.descricao)
                ) {
                    this.countToLoad++;
                }
                if (
                    this.pdadetalhe.assuntovisita &&
                    !this.pdadetalhe.assuntovisita.oculta &&
                    this.agrovisita.assuntovisita &&
                    !this.isNull(this.agrovisita.assuntovisita.descricao)
                ) {
                    this.countToLoad++;
                }
                // console.log('countToLoad', this.countToLoad);
                this.fillSelected();
            }
        },
        fillSelected() {
            // preenche os selects com a seleção vinda com os dados da agro visita
            // console.log(this.isUpdate, this.isLoadingEdit);
            if (this.isUpdate && this.isLoadingEdit) {
                if (!this.isNull(this.agrovisita.idempresa)) {
                    this.empresaSelected = this.empresaSelect.filter(
                        (f) => f.id == this.agrovisita.idempresa
                    )[0];
                }
                if (this.agrovisita.cliente && !this.isNull(this.agrovisita.cliente.nome)) {
                    this.clienteSelected = {
                        id: this.agrovisita.cliente.id,
                        label: this.agrovisita.cliente.nome,
                    };
                }
                if (this.agrovisita.propriedade && !this.isNull(this.agrovisita.propriedade.nome)) {
                    this.propriedadeSelected = {
                        uuid: this.agrovisita.propriedade.uuid,
                        label: this.agrovisita.propriedade.nome,
                    };
                } else {
                    this.disabledByNoPropriedade = true;
                    this.propriedadeLoading = false;
                    this.areaLoading = false;
                    this.talhaoLoading = false;
                    this.planosafraLoading = false;
                }
                if (this.agrovisita.area && !this.isNull(this.agrovisita.area.descricao)) {
                    this.areaSelected = {
                        uuid: this.agrovisita.area.uuid,
                        label: this.agrovisita.area.descricao,
                    };
                }
                if (this.agrovisita.talhao && !this.isNull(this.agrovisita.talhao.descricao)) {
                    this.talhaoSelected = {
                        uuid: this.agrovisita.talhao.uuid,
                        label: this.agrovisita.talhao.descricao,
                    };
                }
                if (this.agrovisita.planosafra && !this.isNull(this.agrovisita.planosafra.uuid)) {
                    // lógica para não pegar valores nullos e mostrar dados estranhos para o usuário
                    let label = '';
                    if (!this.isNull(this.agrovisita.planosafra.safra.descricao)) {
                        label = this.agrovisita.planosafra.safra.descricao;
                    }
                    if (!this.isNull(this.agrovisita.planosafra.tipocultura.descricao)) {
                        if (label != '') label += ' - ';
                        label += this.agrovisita.planosafra.tipocultura.descricao;
                    }
                    this.planosafraSelected = {
                        uuid: this.agrovisita.planosafra.uuid,
                        label: label,
                    };

                    this.safraSelected = {
                        id: this.agrovisita.planosafra.idagrosafra,
                        label: this.agrovisita.planosafra.safra.descricao,
                    };
                    this.culturaSelected = {
                        id: this.agrovisita.planosafra.idtipocultura,
                        label: this.agrovisita.planosafra.tipocultura.descricao,
                    };
                } else {
                    if (this.agrovisita.safra && !this.isNull(this.agrovisita.safra.descricao)) {
                        this.safraSelected = {
                            id: this.agrovisita.safra.id,
                            label: this.agrovisita.safra.descricao,
                        };
                    } else {
                        // porque pode vir vazio
                        this.sendIsChanged('safra');
                    }
                    if (
                        this.agrovisita.cultura &&
                        !this.isNull(this.agrovisita.cultura.descricao)
                    ) {
                        this.culturaSelected = {
                            id: this.agrovisita.cultura.id,
                            label: this.agrovisita.cultura.descricao,
                        };
                    } else {
                        // porque pode vir vazio
                        this.sendIsChanged('cultura');
                    }
                }
                if (
                    this.agrovisita.motivovisita &&
                    !this.isNull(this.agrovisita.motivovisita.descricao)
                ) {
                    this.motivoSelected = {
                        id: this.agrovisita.motivovisita.id,
                        label: this.agrovisita.motivovisita.descricao,
                    };
                } else {
                    // porque pode vir vazio
                    this.sendIsChanged('motivo');
                }
                if (
                    this.agrovisita.assuntovisita &&
                    !this.isNull(this.agrovisita.assuntovisita.descricao)
                ) {
                    this.assuntoSelected = {
                        id: this.agrovisita.assuntovisita.id,
                        label: this.agrovisita.assuntovisita.descricao,
                    };
                }
            }
        },
        loadEmpresa() {
            this.empresaSelect = this.$store.state.user.empresas.map((e) => {
                return { id: e.id, label: e.rsocial };
            });
            //preenche automaticamente se só tiver um valor
            if (this.empresaSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                this.empresaSelected = this.empresaSelect[0];
                this.sendIsChanged('empresa');
            }
            this.empresasLoading = false;
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas
        */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findList(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[AGRO VISITA GERAL] Erro status ${r.status} ao carregar empresas.`
                        );
                        console.error(`[AGRO VISITA GERAL] Mensagem: ${r.message}`);
                    } else {
                        this.empresaSelect = r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                label: e.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error('[AGRO VISITA GERAL] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    if (this.empresaSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.empresaSelected = this.empresaSelect[0];
                        this.sendIsChanged('empresa');
                    }
                    this.empresasLoading = false;
                });
        },
        loadCliente(termo = null, calledBySend = false) {
            if (this.empresaSelected == null) {
                this.clienteLoading = false;
                return;
            }
            /**
             * utilizado para não carregar os dados ao abrir a página pela função de search do vss.
             * assim só carregará pela primeira vez aós ser preenchido com os dados iniciais
             */
            if (!calledBySend && this.isLoadingEdit) return;

            this.clienteLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.empresaSelected != null && this.empresaSelected.id ? 'empresa' : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.empresaSelected != null && this.empresaSelected.id
                    ? this.empresaSelected.id
                    : null,
            ];

            this.serviceCliente
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.nome,
                        };
                    });
                })
                .then((r) => {
                    this.clienteSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (this.clienteSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.clienteSelected = this.clienteSelect[0];
                        this.sendIsChanged('cliente');
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    // retorna como completo
                    this.clienteLoading = false;
                    this.funcCountLoaded(this.clienteSelected);
                });
        },
        loadPropriedade(termo = null, calledBySend = false) {
            if (this.clienteSelected == null) {
                this.propriedadeLoading = false;
                return;
            }

            if (this.pdadetalhe.propriedade && this.pdadetalhe.propriedade.oculta) return;
            if (!calledBySend && this.isLoadingEdit) return;

            this.propriedadeLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.clienteSelected != null && this.clienteSelected.id ? 'cliente' : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.clienteSelected != null && this.clienteSelected.id
                    ? this.clienteSelected.id
                    : null,
            ];

            this.servicePropriedade
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            uuid: i.uuid,
                            label: i.nome,
                            origempda: i.origempda,
                        };
                    });
                })
                .then((r) => {
                    this.propriedadeSelect = Object.assign(r);
                    if (this.propriedadeSelect.length < 1 && this.clienteSelected != null) {
                        // criar validação por plano safra obrigatório na modulopdadetalhe
                        if (
                            this.pdadetalhe['planosafra'] &&
                            this.pdadetalhe['planosafra'].obrigainclusao
                        ) {
                            this.clienteSelected = null;
                            this.$root.showMessage(
                                'alert',
                                'cliente-sem-propriedade-obriga',
                                true,
                                true,
                                10
                            );
                        } else {
                            /**
                             * caso não tenha propriedade, esconde os campos :
                             * propriedade, area, talhao e plano safra
                             */
                            this.disabledByNoPropriedade = true;
                            this.$root.showMessage('alert', 'cliente-sem-propriedade', true);
                            this.disabledByPlanoSafra = false;
                            this.disabledByTalhao = false;
                            // carrega os dados a serem utilizados
                            if (!this.isLoadingEdit) {
                                this.loadSafra();
                                this.loadCultura();
                            }
                        }
                    } else {
                        //preenche automaticamente se só tiver um valor
                        if (
                            this.propriedadeSelect.length == 1 &&
                            !this.cantEdit &&
                            !this.isLoadingEdit
                        ) {
                            this.propriedadeSelected = this.propriedadeSelect[0];
                            this.sendIsChanged('propriedade');
                        }
                        this.disabledByNoPropriedade = false;
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    // retorna como completo
                    this.propriedadeLoading = false;
                    this.funcCountLoaded(this.propriedadeSelected);
                });
        },
        loadArea(termo = null, calledBySend = false) {
            if (this.propriedadeSelected == null) {
                this.areaLoading = false;
                return;
            }

            if (this.pdadetalhe.area && this.pdadetalhe.area.oculta) return;
            if (!calledBySend && this.isLoadingEdit) return;

            this.areaLoading = true;

            let params = [
                // Adicionar filtro complementar
                // filtro de busca
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.propriedadeSelected != null && this.propriedadeSelected.uuid
                    ? 'propriedade'
                    : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.propriedadeSelected != null && this.propriedadeSelected.uuid
                    ? this.propriedadeSelected.uuid
                    : null,
            ];

            this.serviceArea
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            uuid: i.uuid,
                            label: i.descricao,
                            origempda: i.origempda,
                        };
                    });
                })
                .then((r) => {
                    this.areaSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (this.areaSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.areaSelected = this.areaSelect[0];
                        this.sendIsChanged('area');
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    // retorna como completo
                    this.areaLoading = false;
                    this.funcCountLoaded(this.areaSelected);
                });
        },
        loadTalhao(termo = null, calledBySend = false) {
            if (this.areaSelected == null) {
                this.talhaoLoading = false;
                return;
            }

            if (this.pdadetalhe.talhao && this.pdadetalhe.talhao.oculta) return;
            if (!calledBySend && this.isLoadingEdit) return;

            this.talhaoLoading = true;

            let params = [
                // Adicionar filtro complementar
                // filtro de busca
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.areaSelected != null && this.areaSelected.uuid ? 'area' : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.areaSelected != null && this.areaSelected.uuid ? this.areaSelected.uuid : null,
            ];

            this.serviceTalhao
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            uuid: i.uuid,
                            label: i.descricao,
                            origempda: i.origempda,
                        };
                    });
                })
                .then((r) => {
                    this.talhaoSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (this.talhaoSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.talhaoSelected = this.talhaoSelect[0];
                        this.sendIsChanged('talhao');
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    // retorna como completo
                    this.talhaoLoading = false;
                    this.funcCountLoaded(this.talhaoSelected);
                });
        },
        loadPlanoSafra(termo = null, calledBySend = false) {
            if (this.talhaoSelected == null) {
                this.planosafraLoading = false;
                return;
            }

            if (this.pdadetalhe.planosafra && this.pdadetalhe.planosafra.oculta) return;
            if (!calledBySend && this.isLoadingEdit) return;

            this.planosafraLoading = true;

            let params = [
                // Adicionar filtro complementar
                // filtro de busca
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.talhaoSelected != null && this.talhaoSelected.uuid ? 'talhao' : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.talhaoSelected != null && this.talhaoSelected.uuid
                    ? this.talhaoSelected.uuid
                    : null,
            ];

            this.servicePlanoSafra
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        // lógica para não pegar valores nullos e mostrar dados estranhos para o usuário
                        let label = '';
                        if (!this.isNull(i.safra.descricao)) {
                            label = i.safra.descricao;
                        }
                        if (!this.isNull(i.tipocultura.descricao)) {
                            if (label != '') label += ' - ';
                            label += i.tipocultura.descricao;
                        }
                        return {
                            uuid: i.uuid,
                            label: label,
                        };
                    });
                })
                .then((r) => {
                    this.planosafraSelect = Object.assign(r);
                    // Caso não possua plano de safra os campos de safra e cultura serão abertos para serem utilizados.
                    if (this.planosafraSelect.length < 1 && !this.disabledByTalhao) {
                        // criar validação por plano safra obrigatório na modulopdadetalhe
                        if (
                            this.pdadetalhe['planosafra'] &&
                            this.pdadetalhe['planosafra'].obrigainclusao
                        ) {
                            this.talhaoSelected = null;
                            this.$root.showMessage(
                                'alert',
                                'talhao-sem-planosafra-obriga',
                                true,
                                true,
                                10
                            );
                        } else {
                            this.disabledByPlanoSafra = false;
                            if (!this.isLoadingEdit) this.loadSafra();
                            if (!this.isLoadingEdit) this.loadCultura();
                        }
                    } else {
                        //preenche automaticamente se só tiver um valor
                        if (
                            this.planosafraSelect.length == 1 &&
                            !this.cantEdit &&
                            !this.isLoadingEdit
                        ) {
                            this.planosafraSelected = this.planosafraSelect[0];
                            this.sendIsChanged('planosafra');
                        }
                        this.disabledByPlanoSafra = true;
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    // retorna como completo
                    this.planosafraLoading = false;
                    this.funcCountLoaded(this.planosafraSelected);
                });
        },
        loadSafra(termo = null, calledBySend = false) {
            if (
                this.talhaoSelected == null &&
                this.planosafraSelect != null &&
                !this.disabledByNoPropriedade
            ) {
                this.safraLoading = false;
                return;
            }

            if (this.pdadetalhe.safra && this.pdadetalhe.safra.oculta) return;
            if (!calledBySend && this.isLoadingEdit) return;

            this.safraLoading = true;

            this.serviceSafra
                .findAllCombo(termo)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.safraSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (this.safraSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.safraSelected = this.safraSelect[0];
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    // retorna como completo
                    this.safraLoading = false;
                    this.funcCountLoaded(this.safraSelected);
                });
        },
        loadCultura(termo = null, calledBySend = false) {
            if (
                this.talhaoSelected == null &&
                this.planosafraSelect != null &&
                !this.disabledByNoPropriedade
            ) {
                this.culturaLoading = false;
                return;
            }

            if (this.pdadetalhe.cultura && this.pdadetalhe.cultura.oculta) return;
            if (!calledBySend && this.isLoadingEdit) return;

            this.culturaLoading = true;

            this.serviceCultura
                .findAllCombo(termo)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.culturaSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (this.culturaSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.culturaSelected = this.culturaSelect[0];
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    // retorna como completo
                    this.culturaLoading = false;
                    this.funcCountLoaded(this.culturaSelected);
                });
        },
        loadMotivo(termo = null, calledBySend = false) {
            if (this.pdadetalhe.motivo && this.pdadetalhe.motivo.oculta) return;
            if (!calledBySend && this.isLoadingEdit) return;

            if (this.isUpdate && !this.isLoadingEdit && this.motivoSelect.length == 0) return;

            this.motivoLoading = true;

            this.serviceMotivo
                .findAllCombo(termo)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.motivoSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (this.motivoSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.motivoSelected = this.motivoSelect[0];
                        this.sendIsChanged('motivo');
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    // retorna como completo
                    this.motivoLoading = false;
                    this.funcCountLoaded(this.motivoSelected);
                });
        },
        loadAssunto(termo = null, calledBySend = false) {
            if (this.pdadetalhe.assunto && this.pdadetalhe.motivo.assunto) return;
            if (!calledBySend && this.isLoadingEdit) return;

            if (
                (this.pdadetalhe['motivovisita'] && this.pdadetalhe['motivovisita'].oculta) ||
                (this.pdadetalhe['motivovisita'] && !this.pdadetalhe['motivovisita'].obrigainclusao)
            ) {
                this.disabledByMotivo = false;
            }
            this.assuntoLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.motivoSelected != null && this.motivoSelected.id ? 'motivo' : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.motivoSelected != null && this.motivoSelected.id
                    ? this.motivoSelected.id
                    : null,
            ];

            this.serviceAssuntoVisita
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.assuntoSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (this.assuntoSelect.length == 1 && !this.cantEdit && !this.isLoadingEdit) {
                        this.assuntoSelected = this.assuntoSelect[0];
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    // retorna como completo
                    this.assuntoLoading = false;
                    this.funcCountLoaded(this.assuntoSelected);
                });
        },
        loadPlanoSafraByUuid() {
            this.safraLoading = true;
            this.culturaLoading = true;

            this.servicePlanoSafra
                .findByUuid(this.planosafraSelected.uuid)
                .then((r) => {
                    if (!this.isNull(r.content.safra.descricao)) {
                        this.safraSelected = {
                            id: r.content.safra.id,
                            label: r.content.safra.descricao,
                        };
                    }
                    if (!this.isNull(r.content.tipocultura.descricao)) {
                        this.culturaSelected = {
                            id: r.content.tipocultura.id,
                            label: r.content.tipocultura.descricao,
                        };
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.disabledByPlanoSafra = true;
                    this.safraLoading = false;
                    this.culturaLoading = false;
                });
        },
        sendIsChanged(label = null) {
            if (!this.isLoadingEdit) this.$emit('isChanged', true);
            // Já aproveita e faz as validações
            // console.log('alterou', label);
            setTimeout(() => {
                if (this.talhaoSelected == null) this.planosafraSelect = [];

                if (label == 'empresa') {
                    if (!this.isLoadingEdit) this.clienteSelected = null;

                    if (this.empresaSelected != null && this.empresaSelected.id) {
                        this.disabledByEmpresa = false;
                        // carrega select dependente
                        this.loadCliente(null, true);
                    } else {
                        this.disabledByEmpresa = true;
                    }
                }

                if (label == 'cliente') {
                    if (!this.isLoadingEdit) this.propriedadeSelected = null;

                    if (this.clienteSelected != null && this.clienteSelected.id) {
                        this.disabledByCliente = false;
                        // carrega select dependente
                        this.loadPropriedade(null, true);
                    } else {
                        this.disabledByCliente = true;
                    }
                }

                if (label == 'propriedade') {
                    if (!this.isLoadingEdit) this.areaSelected = null;

                    if (this.propriedadeSelected != null && this.propriedadeSelected.uuid) {
                        this.disabledByPropriedade = false;
                        // carrega select dependente
                        this.loadArea(null, true);
                    } else {
                        this.disabledByPropriedade = true;
                    }
                }

                if (label == 'area') {
                    if (!this.isLoadingEdit) this.talhaoSelected = null;

                    if (this.areaSelected != null && this.areaSelected.uuid) {
                        this.disabledByArea = false;
                        // carrega select dependente
                        this.loadTalhao(null, true);
                    } else {
                        this.disabledByArea = true;
                    }
                }

                if (label == 'talhao') {
                    if (!this.isLoadingEdit) {
                        this.planosafraSelected = null;
                        this.safraSelected = null;
                        this.culturaSelected = null;
                    }

                    if (this.talhaoSelected != null && this.talhaoSelected.uuid) {
                        this.disabledByTalhao = false;
                        // carrega select dependente
                        this.loadPlanoSafra(null, true);
                    } else if (this.clienteSelected != null && this.propriedadeSelect.length > 0) {
                        this.disabledByTalhao = true;
                        this.disabledByPlanoSafra = true;
                    }
                }

                if (label == 'planosafra') {
                    if (!this.isLoadingEdit) {
                        this.safraSelected = null;
                        this.culturaSelected = null;
                    }

                    if (this.planosafraSelected != null) {
                        this.loadPlanoSafraByUuid();
                    } else if (this.planosafraSelect.length < 1) {
                        this.disabledByPlanoSafra = false;
                    }
                }

                if (label == 'safra') {
                    if (this.isUpdate && this.isLoadingEdit && this.planosafraSelected == null)
                        this.loadSafra(null, true);
                }
                if (label == 'cultura') {
                    if (this.isUpdate && this.isLoadingEdit && this.planosafraSelected == null)
                        this.loadCultura(null, true);
                }

                if (label == 'motivo') {
                    if (this.isUpdate && this.isLoadingEdit) this.loadMotivo(null, true);

                    if (this.motivoSelected != null && this.motivoSelected.id) {
                        this.disabledByMotivo = false;
                        if (!this.isLoadingEdit) this.assuntoSelected = null;
                        // carrega select dependente
                        this.loadAssunto(null, true);
                    } else {
                        if (
                            this.pdadetalhe['motivovisita'] &&
                            this.pdadetalhe['motivovisita'].obrigainclusao
                        ) {
                            if (!this.isLoadingEdit) this.assuntoSelected = null;
                            this.disabledByMotivo = true;
                        } else {
                            this.loadAssunto(null, true);
                        }
                    }
                }
            }, 200);
        },
        funcCountLoaded(objSelected) {
            // adiciona ao contador de dados carregados da edição
            if (this.isLoadingEdit && objSelected != null) {
                this.countLoaded++;
                /**
                 * caso seja edição e o tanto de dados a serem carregados condizer,
                 * avisa que acabou o loading da edição
                 */
                if (this.countToLoad == this.countLoaded) {
                    setTimeout(() => {
                        this.isLoadingEdit = false;
                    }, 1000);
                }
            }
        },
        promptDelete() {
            let message = this.$t('msg-confirmacao-exclusao-n', { n: '' });
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.save(0),
                onCancel: (_) => this.$emit('deleteVisita', false),
            });
        },
        validacaoPlanoSafra() {
            let validated = true;
            // se tiver pdadetalhe
            if (
                this.pdadetalhe.planosafra &&
                !this.pdadetalhe.planosafra.oculta &&
                this.pdadetalhe.planosafra.obrigainclusao &&
                this.planosafraSelected == null
            ) {
                validated = false;
            }
            // se não tiver pdadetalhe mas tiver planosafra para
            if (
                !this.pdadetalhe.planosafra &&
                this.planosafraSelect.length > 0 &&
                !this.disabledByNoPropriedade &&
                this.planosafraSelected == null
            ) {
                validated = false;
            }
            // se tiver pdadetalhe, não for obrigatório mas tiver planosafra para selecionar
            if (
                this.pdadetalhe.planosafra &&
                !this.pdadetalhe.planosafra.oculta &&
                !this.pdadetalhe.planosafra.obrigainclusao &&
                !this.disabledByNoPropriedade &&
                this.planosafraSelect.length > 0 &&
                this.planosafraSelected == null
            ) {
                validated = false;
            }
            return !validated;
        },
        promptFinalizar() {
            this.$root.confirm({
                message: this.$t('agro-visita-confirmacao-finalizacao'),
                onConfirm: (_) => this.save(1),
                onCancel: (_) => this.$emit('updateSituacao', false),
            });
        },
    },
};
</script>
